import { z } from 'zod'

export const generateNffGnreSchema = z.object({
    startDate: z.date({ required_error: "Data inicial é obrigatória" }),
    endDate: z.date({ required_error: "Data final é obrigatória" }),
});

export const generateNffFileSchema = z.object({
    file: z.instanceof(File, { message: "Arquivo é obrigatório" }),
});

export type GenerateNffGnreFormData = z.infer<typeof generateNffGnreSchema>;
export type GenerateNffFileFormData = z.infer<typeof generateNffFileSchema>;

export type NffTabType = "gnre" | "outros";
